// helpers/IrradianceCache.js
// Simple in-memory cache keyed by segmentId.
// This is independent of POLYGONS array indexing.
export const IRR_CACHE = new Map();

/**
 * Get cached entry (creates empty default if missing).
 */
export function getOrCreateCache(segmentId) {
  if (!segmentId) return null;

  if (!IRR_CACHE.has(segmentId)) {
    IRR_CACHE.set(segmentId, {
      tof: null,
      gti: null,
      asa: null,
      monthlyASA: null,
      irradiancePoints: null,
      status: { tof: "idle", gti: "idle", asa: "idle" },
      error: null,
    });
  }
  return IRR_CACHE.get(segmentId);
}
